import React from 'react'

const InfluenzaMain = () => {
  return (
    <div id='website-responsive' className=''>
    <div className='bg-img' style={{ backgroundImage:'url("influenza-testing/Influenza-Testing-Banner-v2.webp")', height:'100%', width:'100%'}}>
        <div className='toxicology-text-padding'>
            <div className='-max-width display-none-1150'>
                <text className='fs-ss-42 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                RAPID INFLUENZA<br/>
                TESTING IN CHICAGO<br/>
                </text>
            </div>

            <div className='services2-max-width display-block-1150'>
                <text className='fs-ss-32-4 text-montserrat fw-600 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                Rapid Influenza 
                testing in Chicago
                </text>
            </div>
        </div>
    </div>
</div>
  )
}

export default InfluenzaMain